import {
  mdiChevronLeft,
  mdiContentCopy,
  mdiShieldAccount,
  mdiCreditCardCheck,
  mdiPlus,
  mdiMinus,
  mdiReceipt,
  mdiViewDashboard,
  mdiAccountBox,
  mdiHelpBox,
  mdiLadybug,
  mdiFileDownload,
  mdiPlusBox,
  mdiCogBox,
  mdiChevronUp,
  mdiPower,
  mdiInformationOutline,
  mdiCheckCircleOutline,
  mdiProgressClock,
  mdiHelpCircle,
  mdiHelp,
  mdiFileUpload,
  mdiPackage,
  mdiGitlab,
  mdiCog,
  mdiFolder,
  mdiFolderOpen,
  mdiFileImage,
  mdiFileDocument,
  mdiMicrosoftWindows,
} from '@mdi/js'

import logo from '@/assets/logo'

const light = {
  primary: {
    base: '#0f67ff',
    lighten5: '#f5f9ff',
    lighten4: '#e4efff',
    lighten3: '#74abff',
    lighten2: '#478EFF',
    lighten1: '#2678FF',
    darken1: '#0141AF',
    darken2: '#022662',
    darken3: '#031B45',
  },
  secondary: '#050F34',
  accent: '#0f67ff',
  info: '#787B87',
  success: '#149F5C',
  warning: '#F07000',
  error: '#E3063D',
  background: '#F9F9FA',
}

const myIcons = () => ({
  iconfont: 'mdiSvg',
  values: {
    mdiChevronLeft,
    mdiContentCopy,
    mdiShieldAccount,
    mdiCreditCardCheck,
    mdiPlus,
    mdiMinus,
    mdiReceipt,
    mdiViewDashboard,
    mdiAccountBox,
    mdiHelpBox,
    mdiLadybug,
    mdiFileDownload,
    mdiPlusBox,
    mdiCogBox,
    mdiChevronUp,
    mdiPower,
    mdiInformationOutline,
    mdiCheckCircleOutline,
    mdiProgressClock,
    mdiHelpCircle,
    mdiHelp,
    mdiFileUpload,
    mdiPackage,
    logo,
    mdiGitlab,
    mdiCog,
    mdiFolder,
    mdiFolderOpen,
    mdiFileImage,
    mdiFileDocument,
    mdiMicrosoftWindows,
  },
})

export {
  light,
  myIcons,
}
